import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Közös váz a bejelentkezés/regisztráció/jelszó-oldalakhoz.
 *
 * Egy helyen tartja a középre igazítást, a logót, a címsort és a kártyát, hogy
 * a hat auth-oldal ne csússzon el egymástól félpixelenként.
 */
export default function AuthShell({ title, subtitle, children, footer, wide = false }) {
  return (
    <div className="relative min-h-[80vh] flex items-center justify-center px-4 py-16 overflow-hidden">
      {/* Halk fényfolt a kártya mögött */}
      <div
        className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[36rem] h-[36rem] rounded-full
                   blur-3xl pointer-events-none animate-glow-pulse"
        style={{ background: 'radial-gradient(circle, rgba(143,82,201,0.14), transparent 65%)' }}
        aria-hidden="true"
      />

      <div className={`relative w-full ${wide ? 'max-w-lg' : 'max-w-md'} animate-fade-up`}>
        <div className="text-center mb-8">
          <Link to="/" className="inline-block mb-6 group">
            <img
              src="/newlogo.png"
              alt="MortisEngine"
              className="w-14 h-14 mx-auto object-contain
                         drop-shadow-[0_0_18px_rgba(143,82,201,0.45)]
                         group-hover:drop-shadow-[0_0_26px_rgba(143,82,201,0.7)]
                         transition-all duration-300"
            />
          </Link>
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-white mb-2 tracking-tight">
            {title}
          </h1>
          {subtitle && <p className="text-gray-500">{subtitle}</p>}
        </div>

        <div className="card p-6 sm:p-8">{children}</div>

        {footer && <div className="mt-6 text-center">{footer}</div>}
      </div>
    </div>
  );
}
